import apiConfig from '../../config/api_config';

export const ahtApi = {
    getAHTs: (param) => apiConfig.get('/aht/', param),
    newAHT: (ahtData) => apiConfig.post('/aht/', ahtData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }),
    getAHTApplicationStatus: () => apiConfig.get('/aht/application-status/'),
    getAHTById: (ahtId) => apiConfig.get(`/aht/${ahtId}/`),
    updateAHT: (ahtId, ahtData) => apiConfig.put(`/aht/${ahtId}/`, ahtData),
    verifyAHT: (ahtId) => apiConfig.post(`/aht/${ahtId}/verify/`),
    getAHTCases: (ahtId) => apiConfig.get(`/cases/`, { params: { aht_id: ahtId } }),
    getNearbyAHTs: (params) => apiConfig.get('/aht/nearby/', params),
    getAHTProfile: () => apiConfig.get('/aht/me/'),
    addQualification: (ahtId, qualificationData) => apiConfig.post(`/aht/${ahtId}/add_qualification/`, qualificationData),
    addCertification: (ahtId, certificationData) => apiConfig.post(`/aht/${ahtId}/add_certification/`, certificationData),
};
